<template>
  <div class="AdminHeaderWrap">
    <div class="AdminHeaderInner"
     :class="adminMenuData.menuOpenStatus ? '' : 'display_none'">
      <button class="AdminHeader_menuClose" v-on:click="menu_change">
      </button>

      <div class="Admin_Sidemenu">
        <div class="Admin_Sidemenu_MainTit">
          <a href="#" @click.prevent="resetActiveMenu">
            엔포유
          </a>
        </div>

        <div :class="permissionData.permissionArray.includes('1') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('systemManagement')">
              시스템 관리<span class="menu-arrow">{{ menuToggleState.systemManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.systemManagement">
            <p :class="[getSubMenuClass('1-1'), permissionData.permissionArray.includes('1-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('1-1', '/AdminMenuPermissionManagement')">
                메뉴권한 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('1-2'), permissionData.permissionArray.includes('1-2') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('1-2', '/AdminManagement')">
                사용자 관리
              </a>
            </p>
          </div>
        </div>

        <div :class="permissionData.permissionArray.includes('4') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('customerManagement')">
              회원관리<span class="menu-arrow">{{ menuToggleState.customerManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.customerManagement">
            <p :class="[getSubMenuClass('4-1'), permissionData.permissionArray.includes('4-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('4-1', '/AdminCustomerManagement')">
                회원 현황
              </a>
            </p>
            <p :class="[getSubMenuClass('4-2'), permissionData.permissionArray.includes('4-2') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('4-2', '/AdminCouponManagement')">
                쿠폰 관리
              </a>
            </p>
          </div>
        </div>

        <div :class="permissionData.permissionArray.includes('5') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('menuManagement')">
              메뉴관리<span class="menu-arrow">{{ menuToggleState.menuManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.menuManagement">
            <p :class="[getSubMenuClass('5-1'), permissionData.permissionArray.includes('5-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('5-1', '/AdminNewsManagement')">
                공지사항 관리
              </a>
            </p>
          </div>
        </div>

        <div :class="permissionData.permissionArray.includes('2') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('mainManagement')">
              메인화면 관리<span class="menu-arrow">{{ menuToggleState.mainManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.mainManagement">
            <p :class="[getSubMenuClass('2-1'), permissionData.permissionArray.includes('2-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('2-1', '/AdminRollingBannerManagement')">
                롤링 배너 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('2-2'), permissionData.permissionArray.includes('2-2') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('2-2', '/AdminInstockManagement')">
                QUICK DELIVERY 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('2-3'), permissionData.permissionArray.includes('2-3') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('2-3', '/AdminNfuPickManagement')">
                NFU PICK 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('2-4'), permissionData.permissionArray.includes('2-4') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('2-4', '/AdminMonthlyBestManagement')">
                MONTHLY BEST 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('2-5'), permissionData.permissionArray.includes('2-5') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('2-5', '/AdminLivingAccManagement')">
                LIVING ACC 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('2-6'), permissionData.permissionArray.includes('2-6') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('2-6', '/AdminStylingManagement')">
                STYLING 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('2-7'), permissionData.permissionArray.includes('2-7') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('2-7', '/AdminInstagramManagement')">
                인스타그램 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('2-8'), permissionData.permissionArray.includes('2-8') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('2-8', '/AdminTopBannerManagement')">
                탑 배너 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('2-9'), permissionData.permissionArray.includes('2-9') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('2-9', '/AdminBannerManagement')">
                배너 관리
              </a>
            </p>
          </div>
        </div>

        <div :class="permissionData.permissionArray.includes('3') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('productManagement')">
            제품 관리<span class="menu-arrow">{{ menuToggleState.productManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.productManagement">
            <p :class="[getSubMenuClass('3-1'), permissionData.permissionArray.includes('3-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('3-1', '/AdminBrandManagement')">
                브랜드 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('3-2'), permissionData.permissionArray.includes('3-2') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('3-2', '/AdminProductTypeManagement')">
                1단계 : 제품 타입 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('3-3'), permissionData.permissionArray.includes('3-3') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('3-3', '/AdminProductDivisionOneLevelManagement')">
                2단계 : 제품 분류 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('3-4'), permissionData.permissionArray.includes('3-4') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('3-4', '/AdminProductDivisionTwoLevelManagement')">
                3단계 : 제품 분류 관리
              </a>
            </p>
            <p :class="[getSubMenuClass('3-5'), permissionData.permissionArray.includes('3-5') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('3-5', '/AdminProductManagement')">
                제품 등록 및 관리
              </a>
            </p>
          </div>
        </div>

        <div :class="permissionData.permissionArray.includes('6') === true ? '' : 'display_none'">
          <p class="Admin_Sidemenu_Tit" @click="toggleMenu('orderDeliveryManagement')">
            주문 / 배송 관리<span class="menu-arrow">{{ menuToggleState.orderDeliveryManagement ? '▲' : '▼' }}</span>
          </p>
          <div v-if="menuToggleState.orderDeliveryManagement">
            <p :class="[getSubMenuClass('6-1'), permissionData.permissionArray.includes('6-1') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('6-1', '/AdminOrderManagement')">
                주문 현황
              </a>
            </p>
            <p :class="[getSubMenuClass('6-2'), permissionData.permissionArray.includes('6-2') ? '' : 'display_none']">
              <a @click.prevent="setActiveMenu('6-2', '/AdminImmediatePaymentManagement')">바로결제 관리</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div :class="adminMenuData.menuOpenStatus ? 'display_none' : ''">
      <button class="AdminHeader_menuOpen" v-on:click="menu_change">
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import {
  get_session_admin
} from '../../ETC/Axios.vue'
import { ref } from 'vue'

export default {
  name: 'AdminHeader',
  props: ['menu_id', 'menu_check'],
  setup () {
    const getToggleState = () => {
      const savedState = localStorage.getItem('menuToggleState')
      return savedState ? JSON.parse(savedState) : {
        systemManagement: false,
        customerManagement: false,
        menuManagement: false,
        mainManagement: false,
        productManagement: false,
        orderDeliveryManagement: false
      }
    }
    const getMenuOpenStatus = () => {
      const savedStatus = localStorage.getItem('menuOpenStatus')
      return savedStatus ? JSON.parse(savedStatus) : true
    }
    const getActiveMenu = () => {
      return localStorage.getItem('activeMenu') || ''
    }
    return {
      sessionData: ref({
        customer: {}
      }),
      permissionData: ref({
        permissionArray: []
      }),
      adminMenuData: ref({
        menuOpenStatus: getMenuOpenStatus()
      }),
      menuToggleState: ref(getToggleState()),
      activeMenu: ref(getActiveMenu())
    }
  },
  mounted () {
    get_session_admin().then(result => {
      if (result === '') {
        alert('로그인 유지시간이 만료되었습니다.')
        window.location.href = '/AdminLogin'
      } else if (
        !result.menu_permission_array.includes(this.menu_id) &&
        this.menu_check !== false
      ) {
        alert('해당메뉴에 권한이 없습니다.')
        window.location.href = '/AdminMain'
      } else {
        this.sessionData.customer = result
        this.permissionData.permissionArray = JSON.parse(this.sessionData.customer.menu_permission_array)
      }
    })
  },
  methods: {
    resetActiveMenu () {
      localStorage.setItem('activeMenu', '')
      this.activeMenu = ''
      this.$router.push('/AdminMain')
    },
    menu_change () {
      this.adminMenuData.menuOpenStatus = !this.adminMenuData.menuOpenStatus
      localStorage.setItem('menuOpenStatus', JSON.stringify(this.adminMenuData.menuOpenStatus))
    },
    toggleMenu (menuKey) {
      this.menuToggleState[menuKey] = !this.menuToggleState[menuKey]
      localStorage.setItem('menuToggleState', JSON.stringify(this.menuToggleState))
    },
    setActiveMenu (menuId, path) {
      if (this.$route.path !== path) {
        localStorage.setItem('activeMenu', menuId)
        this.activeMenu = menuId
        this.$router.push(path)
      }
    },
    getSubMenuClass (menuKey) {
      return this.activeMenu === menuKey ? 'Admin_Sidemenu_SubTit menu_active' : 'Admin_Sidemenu_SubTit'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Section/AdminHeader.vue